import { useDispatch, useSelector } from "react-redux";
// To use with typescript https://redux.js.org/usage/usage-with-typescript
export var useAppDispatch = useDispatch;
export var useAppSelector = useSelector;
